import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable no-underscore-dangle, complexity */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import X from '@wh/svg-icons/X';
import { withTranslator } from '@wh/ui-translations';
import cx from 'classnames';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';

import translationContext from '../translationContext';
import { getAllowedAttributes, makeFilterLogger } from '../props-filters';
import propTypeClassName from '../propTypeClassName';
import { ENTER, SPACE } from '../keyCodes';
import uuid from '../uuid';
import { category, makeOutfitParser } from '../outfit-parser';
import outfitPropValidator from '../outfitPropValidator';

import * as style from './Tooltip.style';

var modifiersList = ['flexible'];

var parseOutfit = makeOutfitParser(category('modifiers', modifiersList));

var triggerClick = 'click';
var triggerHover = 'hover';

var closeButtonNone = 'none';
var closeButtonVisible = 'visible';
var closeButtonAutoClose = 'autoClose';

var Tooltip = function (_PureComponent) {
  _inherits(Tooltip, _PureComponent);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || _Object$getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: _this.props.defaultOpen,
      tooltipId: undefined,
      ariaBusy: true
    }, _this._getOpenProperty = function () {
      return _this._controlledMode ? _this.props.open : _this.state.open;
    }, _this._autoCloseTimeout = null, _this._controlledMode = _this.props.open != null, _this._handleAutoClose = function () {
      if (_this.props.closeButton === closeButtonAutoClose) {
        _this._autoCloseTimeout = setTimeout(function () {
          return _this._closeTooltip();
        }, 5000);
      }
    }, _this._setupOuterClick = function () {
      if (_this.props.outerClickClose) {
        document.addEventListener('click', _this._handleOuterClick);
      }
    }, _this._handleOuterClick = function (_ref2) {
      var target = _ref2.target;

      if (_this._ref !== target) {
        _this._closeTooltip();
      }
    }, _this._getRef = function (ref) {
      _this._ref = ref;
    }, _this._openTooltip = function () {
      if (!_this._controlledMode) _this.setState({ open: true });
      _this._handleAutoClose();
      _this._setupOuterClick();
    }, _this._closeTooltip = function () {
      if (!_this._controlledMode) {
        _this.setState({ open: false });
        document.removeEventListener('click', _this._handleOuterClick);
      }
      if (_this.props.onClose) _this.props.onClose();
      if (_this._autoCloseTimeout) clearTimeout(_this._autoCloseTimeout);
    }, _this._handleTriggerKeyDown = function (e) {
      if (e.keyCode === ENTER || e.keyCode === SPACE) {
        e.preventDefault();
        _this._handleTriggerClick();
      }
    }, _this._handleTriggerClick = function () {
      if (!_this._controlledMode && _this.props.trigger === triggerClick) {
        (_this._getOpenProperty() ? _this._closeTooltip : _this._openTooltip)();
      }
    }, _this._handleTriggerMouseEnter = function () {
      if (!_this._controlledMode && _this.props.trigger === triggerHover) _this._openTooltip();
    }, _this._handleTriggerMouseLeave = function () {
      if (!_this._controlledMode && _this.props.trigger === triggerHover) _this._closeTooltip();
    }, _this._handleTriggerFocus = _this._handleTriggerMouseEnter, _this._handleTriggerBlur = _this._handleTriggerMouseLeave, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      /* If open by default, handle auto closing and outer click */
      if (this._getOpenProperty()) {
        this._handleAutoClose();
        this._setupOuterClick();
      }

      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        tooltipId: uuid(),
        ariaBusy: false
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      /* Handle auto closing and outer click once programmatically opened */
      if (!this._controlledMode || this.props.open === prevProps.open) return;
      if (this.props.open) {
        this._handleAutoClose();
        this._setupOuterClick();
      } else {
        document.removeEventListener('click', this._handleOuterClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._autoCloseTimeout) clearTimeout(this._autoCloseTimeout);
      document.removeEventListener('click', this._handleOuterClick);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          children = _props.children,
          tip = _props.tip,
          className = _props.className,
          position = _props.position,
          closeButton = _props.closeButton,
          outfit = _props.outfit,
          restProps = _objectWithoutProperties(_props, ['t', 'children', 'tip', 'className', 'position', 'closeButton', 'outfit']);

      var flexible = parseOutfit(outfit).get('modifiers').has('flexible');
      var open = this._getOpenProperty();
      var allowedAttributes = getAllowedAttributes(restProps, makeFilterLogger(Tooltip));
      var displayCloseButton = [closeButtonVisible, closeButtonAutoClose].includes(closeButton);
      var tooltipContentClassModifier = displayCloseButton ? style.tooltipContentNarrower : '';
      var tooltipContentFlexible = flexible ? style.tooltipContentFlexible : '';
      var tooltipPosition = upperFirst(camelCase(position));

      return React.createElement(
        'div',
        _extends({}, allowedAttributes, {
          className: cx(style.tooltip, className),
          'aria-busy': this.state.ariaBusy
        }),
        React.createElement(
          'div',
          {
            className: style.tooltipTrigger,
            onClick: this._handleTriggerClick,
            onKeyDown: this._handleTriggerKeyDown,
            onMouseEnter: this._handleTriggerMouseEnter,
            onMouseLeave: this._handleTriggerMouseLeave,
            onFocus: this._handleTriggerFocus,
            onBlur: this._handleTriggerBlur,
            'data-test-id': 'Tooltip.button-trigger',
            'aria-describedby': this.state.tooltipId,
            role: this._controlledMode ? undefined : 'button',
            tabIndex: this._controlledMode ? undefined : 0
          },
          children
        ),
        open && React.createElement(
          'div',
          {
            className: cx(style.tooltipTipWrapper(flexible), style['tooltipTipWrapper' + tooltipPosition])
          },
          React.createElement(
            'div',
            {
              id: this.state.tooltipId,
              role: 'tooltip',
              className: cx(style.tooltipTip(flexible), style['tooltipTip' + tooltipPosition])
            },
            React.createElement(
              'div',
              { className: style.tooltipContentWrapper },
              React.createElement(
                'div',
                {
                  ref: this._getRef,
                  className: cx(style.tooltipContent, tooltipContentClassModifier, tooltipContentFlexible),
                  'data-test-id': 'Tooltip.tip'
                },
                tip
              )
            ),
            displayCloseButton && React.createElement(
              'button',
              {
                tabIndex: 0,
                className: style.tooltipCloseButton,
                onClick: this._closeTooltip,
                'data-test-id': 'Tooltip.button-close',
                'aria-label': translationContext(t)('close')
              },
              React.createElement(X, null)
            )
          )
        )
      );
    }
  }]);

  return Tooltip;
}(PureComponent);

Tooltip.propTypes = {
  /** @ignore */
  t: PropTypes.func.isRequired,
  /**
   * Choose whether a tooltip should have a close button and how it should behave
   *
   * - none - close button is not displayed at all (chosen by default)
   *
   * - visible - close button is displayed and when it is clicked,
   * tooltip closes itself (uncontrolled mode)
   * or fires onClose callback (controlled mode)
   *
   * - autoClose - close button is displayed with the same behaviour as for 'visible' option,
   * but additionally tooltip closes itself after 5s (uncontrolled mode)
   * or fires onClose callback instead (controlled mode)
   */
  closeButton: PropTypes.oneOf([closeButtonNone, closeButtonVisible, closeButtonAutoClose]),
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   *
   * Options:
   *
   *    - Modifiers: "**flexible**"
   */
  outfit: outfitPropValidator([].concat(modifiersList)),
  /** Defines the default state for uncontrolled mode */
  defaultOpen: PropTypes.bool,
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   */
  className: propTypeClassName,
  /** Rendered as a trigger for tooltip */
  children: PropTypes.node,
  /** Content of tooltip */
  tip: PropTypes.node,
  /** Event that triggers display of tooltip - works only for uncontrolled mode */
  trigger: PropTypes.oneOf([triggerHover, triggerClick]),
  /** Defines whether tooltip is open or closed (controlled mode). Has higher priority than uncontrolled mode */
  open: PropTypes.bool,
  /** Tooltip position */
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'top-left', 'top-right', 'bottom-right', 'bottom-left']),
  /** Fired once Tooltip closes (uncontrolled mode) or close action is being requested (controlled mode) */
  onClose: PropTypes.func,
  /** Decides whether outer click should close tooltip */
  outerClickClose: PropTypes.bool
};
Tooltip.defaultProps = {
  defaultOpen: false,
  closeButton: closeButtonNone,
  trigger: triggerHover,
  position: 'top',
  outerClickClose: false
};


export default withTranslator(Tooltip);